module.exports = __webpack_public_path__ + "img/3.a353b830.jpg";